export const load = () => ({
	title: 'How to Soundproof a Home Office',
	showTitle: true,
});
